var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Moon = function Moon(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.15 4.882A8 8 0 1 0 19.353 15.03 8.499 8.499 0 0 1 8.15 4.882Zm1.314-2.65.257-.07a1 1 0 0 1 1.115 1.49 6.5 6.5 0 0 0 9.475 8.584 1 1 0 0 1 1.6.92A10 10 0 1 1 9.339 2.258c.041-.01.083-.02.125-.025Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Moon;